"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateChildDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
class UpdateChildDetailsDto {
}
exports.UpdateChildDetailsDto = UpdateChildDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "ID of the child details", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateChildDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateChildDetailsDto.prototype, "contactDetailsId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Child Gender of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Child Gender should be a number" }),
    tslib_1.__metadata("design:type", Number)
], UpdateChildDetailsDto.prototype, "childGender", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "child Name", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Child name should be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Child name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateChildDetailsDto.prototype, "childName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Child Date of Birth", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "Child date of birth should be a date" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateChildDetailsDto.prototype, "childDob", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateChildDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateChildDetailsDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], UpdateChildDetailsDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], UpdateChildDetailsDto.prototype, "updatedAt", void 0);
